export default __webpack_public_path__ + "static/media/BAN2.ceb74998.webp";